import _ from 'lodash'

const contentCategory = [
    { key: "GENERAL_CONTENT",           value: "General Content" },
    { key: "TRAINING_COURSES",          value: "Training Courses" },
    { key: "CASE_STUDIES",              value: "Case Studies" },
    // Legacy — remove after content migration
    { key: "INTERNATIONAL_EXPANSION",   value: "International Expansion" },
    { key: "PRODUCTIVITY_IMPROVEMENTS", value: "Productivity Improvements" },
    { key: "SALES_EFFECTIVENESS",       value: "Sales Effectiveness" },
    { key: "GLOBAL_SOURCING",           value: "Global Sourcing" },
];

function findByKeyOrValue(array, searchTerm) {
    return _.find(array, obj => obj.key === searchTerm || obj.value === searchTerm);
}

export { contentCategory };